export const toPrice = (price: number | string) => {
  if (typeof price === "string") {
    price = parseFloat(price);
  }
  return price.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
  });
};
